import React from 'react';

import PropTypes from 'prop-types';
import { isPaymentRegion } from '../../utils/helpers';

class RegionSummary extends React.Component {
  render = () => {
    const region = this.props.region ? this.props.region : { key: 'rft', id: null };
    const paymentEnabled = region.id ? isPaymentRegion(region.id) : false;

    return <React.Fragment>
      <>
        <p className='text-muted mb-3'>
          {region.key !== 'rft' &&
            <span>It looks like you would be part of the <b style={{ fontWeight: 'bold' }}>{region.description || region.name || 'your'}</b>
              {region.territories &&
                <span>, which includes core territories of the <b style={{ fontWeight: 'bold' }}>{region.territories}</b></span>
              }
              .
            </span>
          }
          {region.key === 'rft' &&
            <span>It looks like you are outside of Reciprocity's current Regional Trust Area boundaries.</span>
          }
        </p>
        {!paymentEnabled && region.id === 'rgn_3' &&
          <p className='text-muted mb-3'>
            We are working diligently at the pace of trust to get up and running in your area - please make a pledge to join. This helps provide momentum and demonstrate that there are homes and small businesses like yours that are ready and willing to more meaningfully recognize the Indigenous lands we have come to call home.
          </p>
        }
        {!paymentEnabled && region.id !== 'rgn_3' &&
          <p className='text-muted mb-3'>
            Make a pledge to join Reciprocity once we are up and running in your area!
          </p>
        }
      </>
    </React.Fragment>
  }
}

RegionSummary.propTypes = {
  region: PropTypes.object.isRequired
};

export default RegionSummary;
